import { useEffect, useRef } from "react";

function useOutsideClick(handler, listen = true) {
  const ref = useRef(null);
  useEffect(
    function () {
      function handleClick(e) {
        if (ref.current && !ref.current.contains(e.target)) {
          handler();
        }
      }

      document.addEventListener("click", handleClick, listen);

      return () => document.removeEventListener("click", handleClick, listen);
    },
    [handler, listen]
  );
  return ref;
}

export default useOutsideClick;
